import { get, writable, derived } from 'svelte/store';
import { translations } from './translations';
import { detectLanguage } from './language-utils';

const languageMap = [
    {key: "en", name: "English"},
    {key: "es", name: "Español"},
    {key: "de", name: "Deutsch"},
    {key: "fr", name: "Français"},
    {key: "it", name: "Italiano"},
    {key: "ru", name: "Русский"},
    {key: "be", name: "Беларуская"},
    {key: "kk", name: "Қазақша"},
    {key: "uz", name: "O'zbek"},
    {key: "tr", name: "Türkçe"},
    {key: "ka", name: "ქართული"},
    {key: "ko", name: "한국어"},
    {key: "hi", name: "हिन्दी"},
    {key: "bn", name: "বাংলা"},
    {key: "id", name: "Bahasa Indonesia"},
    {key: "ms", name: "Bahasa Melayu"},
    {key: "zh", name: "中文"},
    {key: "ja", name: "日本語"},
    {key: "pt", name: "Português"}
];

export const languages = {};

(M.publishConfig.langs || []).forEach(x => {
    const found = languageMap.find(lang => x === lang.key);
    if (found) {
        languages[found.key] = found.name;
    }
});

export const languagesCount = Object.entries(languages).length;

const langKeys = (M.publishConfig.langs || []);
const defaultLangKey = M.publishConfig.defaultLang || langKeys[0] || 'en';

function createLanguageStore() {
    const { subscribe, set, update } = writable(detectLanguage(langKeys, defaultLangKey));

    // Listen for URL changes (for SPA navigation)
    if (typeof window !== 'undefined') {
        window.addEventListener('popstate', () => {
            const detectedLang = detectLanguage(langKeys, defaultLangKey);
            set(detectedLang);
        });
    }

    return {
        subscribe,
        setLanguage: (language) => {

            if (!translations[language]) {
                language = defaultLangKey;
            }
            set(language);
            // Update URL without reloading the page
            const url = new URL(window.location);
            url.searchParams.set('lang', language);
            window.history.pushState({}, '', url);

        },
        reset: () => {

            set(M.publishConfig.defaultLang);
            // Remove lang parameter from URL
            const url = new URL(window.location);
            url.searchParams.delete('lang');
            window.history.pushState({}, '', url);
        }
    };
}

export const language = createLanguageStore();

export const t = derived(
    language,
    $language => (key) => {
        const keys = key.split('.');
        let value = translations[$language];
        
        for (const k of keys) {
            if (value === undefined) return key;
            value = value[k];
        }
        
        return value || key;
    }
);

/**
 *
 * @param key - 'text.text'
 * @param data - {max: 5}
 * @returns {*}
 */
export const instantTranslate = (key, data) => {

    let value = get(t)(key) || key;

    if(!data) {
        return  value;
    }

    const replaces = Object.keys(data);
    (replaces || []).forEach(r => {
        value = value.replace(`{${r}}`, data[r])
    });

    return value;
}
